import { TDeviceType } from '@cian/ui-kit';
import { InlineFactoidItem } from 'shared/components/FactoidsList';
import { IFactoid } from 'shared/types/houseInfo/factoid';
import { renderFactoids } from './renderFactoids';
import { splitIntoTwoColumns } from './splitIntoTwoColumns';

import type { JSX } from "react";

export const getFactoidsViewByDeviceType = (factoids: IFactoid[], deviceType: TDeviceType): JSX.Element[] =>
  deviceType === 'desktop'
    ? splitIntoTwoColumns(factoids).map((factoidsRow, index) => (
        <div key={index}>{renderFactoids(factoidsRow, InlineFactoidItem)}</div>
      ))
    : renderFactoids(factoids, InlineFactoidItem);
